<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '~ds/lib/utils'

import type { SpotlightVariants } from '.'

import { spotlightVariants } from '.'

const props = defineProps<{
  color?: SpotlightVariants['color'];
  size?: SpotlightVariants['size'];
  position?: SpotlightVariants['position'];
  class?: HTMLAttributes['class'];
}>()
</script>

<template>
  <div
    data-slot="spotlight"
    aria-hidden="true"
    :class="cn(spotlightVariants({ color, size, position }), props.class)"
  />
</template>
